import React, { useCallback } from "react";
import { push } from "connected-react-router";
import { useIntl } from "react-intl";
import { connect } from "react-redux";

import TableHeader from "../../app/generic/tableHeader";
import TooltipButton from "../../app/generic/tooltipButton";
import FilterButton from "../../app/generic/tableFilter/filterButton";

function NotificationListHeader({ push, showFilter, onFilterClick }) {
  const intl = useIntl();
  const handleNewClick = useCallback(() => {
    push("/new-notification");
  }, [push]);

  return (
    <TableHeader
      title={intl.formatMessage({
        id: "notification.list",
        defaultMessage: "Notifikace",
      })}
      left={<FilterButton showFilter={showFilter} onClick={onFilterClick} />}
      right={
        <TooltipButton
          icon="plus"
          onClick={handleNewClick}
          text={intl.formatMessage({
            id: "notification.createNew",
            defaultMessage: "Vytvořit novou notifikaci",
          })}
        />
      }
    />
  );
}

export default connect(null, { push })(NotificationListHeader);
